/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 閲覧可能な営業所一覧、ドロップダウンで表示用に名称が入る
 * @export
 * @interface BrowsableOffice
 */
export interface BrowsableOffice {
    /**
     * 営業所ID
     * @type {number}
     * @memberof BrowsableOffice
     */
    officeId: number;
    /**
     * 営業所名称
     * @type {string}
     * @memberof BrowsableOffice
     */
    officeName: string;
}

export function BrowsableOfficeFromJSON(json: any): BrowsableOffice {
    return BrowsableOfficeFromJSONTyped(json, false);
}

export function BrowsableOfficeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrowsableOffice {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'officeId': json['office_id'],
        'officeName': json['office_name'],
    };
}

export function BrowsableOfficeToJSON(value?: BrowsableOffice | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'office_id': value.officeId,
        'office_name': value.officeName,
    };
}


